// extracted by mini-css-extract-plugin
export default {"container":"impressum_container__rdV8M","overview":"impressum_overview__vGMTf","tile":"impressum_tile__LAIBq","title":"impressum_title__YLFUg"};